import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./Components/Login/LoginComponent";
import Header from "./Components/Header/HeaderComponent";
import Dashboard from "./Components/Dashboard/DashboardComponent";
import PurchasedProducts from "./Components/Account/PurchasedProducts";
import Admin from "./Components/Admin/AdminComponent";
import SyncPage from "./Components/Sync/SyncComponent";
import Modal from "react-modal";
import loadingOrderGif from "./loadingOrder.gif";
import Clarity from "@microsoft/clarity";
import AlertModal from "./Components/AlertModal/AlertModal";

function Fullagroapp() {
  const projectId = "r3zs3wp8mk";
  Clarity.init(projectId);
  const [auth, setAuth] = useState(
    localStorage.getItem("token") ? true : false
  );
  const [orderSummary, setOrderSummary] = useState([]);
  const [confirmOrderLoader, setConfirmOrderLoader] = useState(false);
  const [modalOrderIsOpen, setModalOrderIsOpen] = useState(false);
  const [alert, setAlert] = useState(null);

  const modAuthTrue = () => setAuth(true);
  const modAuthFalse = () => {
    setAuth(false);
    setOrderSummary([]);
  };

  const openOrderModal = () => {
    if (orderSummary.length > 0) {
      setModalOrderIsOpen(true);
    } else {
      // The dashboard already shows an alert modal for this case
      // We just don't open the order modal
    }
  };

  const closeOrderModal = () => {
    setModalOrderIsOpen(false);
  };

  const handleConfirmOrder = async () => {
    setConfirmOrderLoader(true);
    const token = localStorage.getItem("token");
    try {
      const response = await fetch("https://api.fullagro.com:8888/orders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          orders: orderSummary,
        }),
      });

      if (response.ok) {
        setAlert({ variant: "success", title: "Pedido confirmado", message: "Hemos creado tu pedido. Recibirás una copia por email." });
        setOrderSummary([]);
        setTimeout(() => window.location.reload(), 1200);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error creating orders:", error.message);
      if (error.message.includes("401")) {
        setAlert({ variant: "error", title: "Sesión expirada", message: "Tu sesión ya no es válida. Por favor, vuelve a iniciar sesión." });
      } else {
        setAlert({ variant: "error", title: "Error al procesar", message: "No pudimos crear el pedido. Inténtalo de nuevo en unos segundos." });
      }
    } finally {
      setConfirmOrderLoader(false);
      setModalOrderIsOpen(false);
    }
  };

  const handleQuantityChange = (index, newQuantity) => {
    setOrderSummary((prevOrderSummary) =>
      prevOrderSummary.map((item, i) =>
        i === index ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const handleRemoveProduct = (index) => {
    setOrderSummary((prevOrderSummary) =>
      prevOrderSummary.filter((_, i) => i !== index)
    );
  };

  return (
    <Router>
      <div id="app">
        <Header
          auth={auth}
          modAuthFalse={modAuthFalse}
          orderSummary={orderSummary}
          openOrderModal={openOrderModal}
        />
        <Routes>
          <Route
            path="/"
            element={
              auth ? (
                <Dashboard
                  setOrderSummary={setOrderSummary}
                  orderSummary={orderSummary}
                  modAuthFalse={modAuthFalse}
                />
              ) : (
                <Login modAuthTrue={modAuthTrue} />
              )
            }
          />
          <Route
            path="/account"
            element={
              auth ? <PurchasedProducts /> : <Navigate to="/" replace />
            }
          />
          <Route
            path="/admin"
            element={
              auth ? <Admin /> : <Navigate to="/" replace />
            }
          />
          <Route
            path="/sync"
            element={
              auth ? <SyncPage /> : <Navigate to="/" replace />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {confirmOrderLoader && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              zIndex: 9999,
            }}
          >
            <h2>
              <b>Creating Order.</b>
            </h2>
            <img
              src={loadingOrderGif}
              alt="Loading..."
              style={{
                width: "6rem",
                height: "6rem",
              }}
            />
          </div>
        )}

        <Modal
          isOpen={modalOrderIsOpen}
          onRequestClose={closeOrderModal}
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "60%",
              textAlign: "center",
              background: "rgb(216, 228, 214)",
            },
          }}
          contentLabel="Order Summary"
        >
          <h2>Order Summary</h2>
          {orderSummary.length > 0 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Strain
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Batch ID
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Quantity
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {orderSummary.map((item, index) => (
                  <tr key={index}>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      {item.strain}
                    </td>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      {item.batchID}
                    </td>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      <input
                        type="number"
                        min="0"
                        value={item.quantity}
                        onChange={(e) =>
                          handleQuantityChange(
                            index,
                            parseInt(e.target.value) || 0
                          )
                        }
                        style={{ width: "60px" }}
                      />
                    </td>
                    <td style={{ border: "1px solid #000", padding: "8px" }}>
                      <button onClick={() => handleRemoveProduct(index)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No products added to the order.</p>
          )}
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              gap: "0.5rem",
              justifyContent: "flex-end",
            }}
          >
            <button onClick={closeOrderModal} className="btn secondary">Cancel</button>
            <button onClick={handleConfirmOrder} className="btn">Confirm Order</button>
          </div>
        </Modal>
      </div>
      <AlertModal
        open={!!alert}
        variant={alert?.variant}
        title={alert?.title}
        message={alert?.message}
        onClose={() => setAlert(null)}
      />
    </Router>
  );
}

export default Fullagroapp;